import ActionType from '../actions/ActionType'
export default (
  state = {
    completed: {},
    plans: [],
    subscription: null,
    customer: null,
    loading_customer: true,
    show_payments_modal: false,
  },
  action,
) => {
  switch (action.type) {
    case ActionType.PAYMENTS_MANAGER.CLIENT_TOKEN_READ_SUCCESS:
      return {
        ...state,
        client_token: action.payload,
      }
    case ActionType.PAYMENTS_MANAGER.PLANS_READ_SUCCESS:
      return {
        ...state,
        plans: action.payload,
      }
    case ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_REQUEST:
      return {
        ...state,
        loading_customer: true,
      }
    case ActionType.PAYMENTS_MANAGER.SUBSCRIPTION_READ_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
      }
    case ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_SUCCESS:
      const customer = action.payload

      // const customerPaymentMethod = customer
      //   ? customer.paymentMethods
      //     ? customer.paymentMethods.find((pm) => pm.default)
      //     : undefined
      //   : undefined

      let subscription = null

      if (customer && customer.paymentMethods) {
        customer.paymentMethods.find((pm) => {
          if (pm.subscriptions.length) {
            const found =
              pm.subscriptions.find(
                (sub) =>
                  sub.status === 'Active' ||
                  sub.status === 'PastDue' ||
                  sub.status === 'Pending',
              ) || null
            subscription = found
            return found
          }
          return false
        })
      }

      // const subscription = customerPaymentMethod
      //   ? customerPaymentMethod.subscriptions.length
      //     ? customerPaymentMethod.subscriptions.find(
      //         (sub) =>
      //           sub.status === 'Active' ||
      //           sub.status === 'PastDue' ||
      //           sub.status === 'Pending',
      //       )
      //     : undefined
      //   : undefined

      return {
        ...state,
        loading_customer: false,
        customer,
        subscription,
      }
    case ActionType.PAYMENTS_MANAGER.CUSTOMER_READ_FAILURE:
      return {
        ...state,
        loading_customer: true,
        error: action.payload,
      }
    case ActionType.PAYMENTS_MANAGER.OPEN_PAYMENTS_MODAL:
      return {
        ...state,
        show_payments_modal: action.show !== undefined ? action.show : false,
      }
    // case ActionType.PAYMENTS_MANAGER.UPDATE_ADDRESS_SUCCESS:
    //   if (state.customer && Array.isArray(state.customer.addresses)) {
    //     return {
    //       ...state,
    //       customer: {
    //         ...state.customer,
    //         addresses: state.customer.addresses.map((address) => {
    //           if (address.id !== action.id) return address
    //           return action.payload.address
    //         }),
    //       },
    //     }
    //   }
    //   return state
    default:
      return state
  }
}
